export default "__VITE_ASSET__HFkeSaM1__"